import ConnectivityService from "../../../../app/Merchant/service/ConnectivityService"

class PendingQueueClass {
    constructor() {
        this.pendingQueue = []
    }
    init = (app) => {
        this.app = app
    }
    setNoConnection = (queueItem, isNoConnection) => {
        if (isNoConnection) {
            $(document).trigger('BackgroundQueueFab.show', [true])
        }
        queueItem.isNoConnection = isNoConnection
        this.fab && this.fab.forceUpdate()
    }
    setPending = (queueItem) => {
        queueItem.pending = true
        queueItem.done = false
        queueItem.error = false
        this.fab && this.fab.forceUpdate()
    }
    setError= (queueItem) => {
        queueItem.pending = false
        queueItem.done = false
        queueItem.error = true

        // Task failed, open the Fab to show details to user
        this.fab && this.fab.showPendingQueueDetails()
    }
    setDone = (queueItem) => {
        queueItem.pending = false
        queueItem.done = true
        queueItem.error = false

        if (queueItem.timer) {
            clearTimeout(queueItem.timer)
            queueItem.timer = null
        }

        this.fab && this.fab.forceUpdate()
    }
    isPromise = (obj) => {
        // To check if object is a Promise
        // https://medium.com/@Carmichaelize/javascript-testing-for-promises-6c834afc33a8
        return Promise.resolve(obj) == obj
    }

    clearTimer = (queueItem) => {
        if (!queueItem) {
            throw "Queue Item not provided"
        }
        if (queueItem.timer) {
            clearTimeout(queueItem.timer)
            queueItem.timer = null
        }
    }

    /**
     * Execute the promise. Caller needs to manually resolve
     * queueItem and extract the promise object first.
     * On success, will remove queueItem from PendingQueue and clear the retry timer.
     * If caller unable resolve/reject the promise before timer ends,
     * if we has retry timer, we we will retry the action.
     */
    executePromise = (promise, queueItem) => {
        promise.then((res) => {
            this.completeAndRemove(queueItem)
            return res
        }, (error) => {
            this.setError(queueItem)

            // Remove "waiting API response" timer and allow
            // error handler to handle the retry 
            this.clearTimer(queueItem)

            $(document).trigger('BackgroundQueueFab.show', [true])
            this.handleAutoRetry(queueItem)
            return error
        })
        .finally(() => {
            this.clearTimer(queueItem)
        })
    }
    handleAutoRetry = (queueItem) => {
        if (queueItem.autoRetry && queueItem.maxRetryCount) {
            queueItem.retryAttempted = queueItem.retryAttempted || 0
            if (queueItem.retryAttempted < queueItem.maxRetryCount) {
                queueItem.retryAttempted++
                this.retry(queueItem)
            }
            else {
                queueItem.waitingManualRetry = true
            }
        }
    }
    retry = (queueItem) => {
        this.setPending(queueItem)
        ConnectivityService.checkConnectivity()
            .then(() => {
                if (queueItem._removed) {
                    // Job already removed while we are performing
                    // connectivity check, abort
                    return
                }
                if (queueItem.action) {
                    const timeout = parseInt(queueItem.timeout || 0)
                    if (timeout) {
                        this.clearTimer(queueItem)
                        queueItem.timer = setTimeout(() => {
                            this.handleAutoRetry(queueItem, "No response from server")
                        }, timeout);
                    }

                    this.setNoConnection(queueItem, false)
                    if (typeof queueItem.action === 'function') {
                        // queueAction is callback function,
                        // execute the function. The function itself
                        // should be in charge of calling PendingQueue.remove()
                        // on success execution
                        let a = queueItem.action(queueItem.retryAttempted)
                        if (this.isPromise(a)) {
                            // This callback function returns a Promise instead,
                            // execute the promise
                            this.executePromise(a, queueItem)
                        }
                    }
                    else if (this.isPromise(queueItem.action)) {
                        // queueAction is Promise
                        this.executePromise(queueItem.action, queueItem)
                    }
                    else {
                        // Not a valid action, clear timer to avoid infinite retry loop
                        this.clearTimer(queueItem)
                    }
                }
            })
            .catch(() => {
                this.setNoConnection(queueItem, true)

                // Wait 10 seconds, then retry
                // We use the shared timer, so that
                // somehow the action able to success/resolve/user trigger retry without internet
                // connection, shall abort the retry
                // Retry due to no internet connection this one we can retry indefinitely
                // until connectivity is restored
                this.setRetryTimer(queueItem, 10 * 1000)
            })
    }

    setRetryTimer = (queueItem, timeout) => {
        if (timeout <= 30) {
            // Perhaps we made a mistake and pass in "second" instead of "milisecond"
            timeout = timeout * 1000
        }
        else if (timeout < 5000) {
            // Mininum retry delay = 5 second
            timeout = 5 * 1000
        }
        this.clearTimer(queueItem)
        queueItem.timer = setTimeout(() => {
            this.retry(queueItem)
        }, timeout)
    }
    /**
     * Add a new background task to BackgroundQueue
     * queueAction should contain
     * action   - Closure to be executed
     * name     - Name to be displayed to user
     *
     * Simple example:
     *
     * let a = {
     *      action: () => {
     *          let callback = () => {
     *              // Your callback code here
     *              ...
     *
     *              // Remove from BackgroundQueue when async task
     *              // is completed
     *              PendingQueue.remove(a)
     *          }
     *          someAsyncTask(callback)
     *      },
     *
     *      OR
     *
     *      action: new Promise((resolve, reject) => {
     *          // Your function here
     *          // On resolve(), PendingQueue will remove the queue item
     *          resolve()
     *
     *      })
     *
     *      name: "My dummy async task"
     * }
     *
     * PendingQueue.add(a)
     *
     *
     * @param {Object} queueItem
     */
    add = (queueItem) => {
        if (queueItem.timeout === undefined) {
            // By default if task not complete within 20 seconds,
            // then shall retry
            queueItem.timeout = 20 * 1000
        }
        this.pendingQueue.push(queueItem)
        this.retry(queueItem)
    }
    completeAndRemove = (queueItem) => {
        // Let user knows that task had completed, before
        // remove from UI
        this.setDone(queueItem)
        this.remove(queueItem, queueItem.removeFromUiAfter || 3000)
    }
    remove = (queueItem, removeFromUiAfter) => {
        // Mark that no further actions shall be taken\
        queueItem._removed = true

        // Remove timer to avoid accidentally retry
        this.clearTimer(queueItem)

        // Remove from UI
        setTimeout(() => {
            for (let i = 0; i < this.pendingQueue.length; i++) {
                if (queueItem === this.pendingQueue[i]) {
                    this.pendingQueue.splice(i,1)
                    this.app.forceUpdate()
    
                    if (this.pendingQueue.length == 0) {
                        // No more tasks, hide the details so that on
                        // new task added, the detail will not be shown
                        // until admin click the Fab button
                        this.fab && this.fab.hidePendingQueueDetails()
                    }
                    this.fab && this.fab.forceUpdate()
                    break;
                }
            }
        }, removeFromUiAfter && removeFromUiAfter > 0 ? removeFromUiAfter : 100);
    }
    /**
     * Set reference to BackgroundQueueFab
     * so that can call BackgroundQueueFab's method
     * @param {BackgroundQueueFab} fab
     */
    setFab = (fab) => {
        this.fab = fab
    }
}

export default new PendingQueueClass();